import { HttpClient, HttpParams } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { ICountry } from "@app/directives/_forms/smsInput/ICountry";
import { IPreferencesContent } from "@app/interfaces/IPreferencesContent";
import { ITimeZoneInfo } from "@app/userPreferences/model/ITimeZoneInfo";
import copy from "fast-copy";
import { forkJoin, Observable, of } from "rxjs";
import { map } from "rxjs/operators";
import { IPreferencesQueryOptions } from "../preferences.service";

@Injectable({
    providedIn: 'root'
})
export class PreferenceService {

    constructor(
        private readonly http: HttpClient
    ) { }

    getPreferences(queryOptions: IPreferencesQueryOptions): Observable<IPreferencesContent> {
        return this.http.get<IPreferencesContent>("/api/preferences/preferencesContent", { params: queryOptions as HttpParams });
    }

    getDefaultPreferences(): Observable<IPreferencesContent> {
        return this.http.get<IPreferencesContent>("/api/preferences/default");
    }

    getAccountPreferences(queryOptions: IPreferencesQueryOptions): Observable<IPreferencesContent> {
        let prefsObservable = this.getPreferences(queryOptions);

        if (!queryOptions.AccountId) {
            prefsObservable = of<IPreferencesContent>({})
        }

        return forkJoin({
            prefs: prefsObservable,
            defaultPrefs: this.getDefaultPreferences()
        }).pipe(map(data => {
            const mergedPrefs: IPreferencesContent = copy({ ...data.defaultPrefs, ...data.prefs });
            this.setExistingPrefProperties(data.prefs, mergedPrefs);
            return mergedPrefs;
        }))
    }

    getCountryCodes(): Observable<ICountry[]> {
        return this.http.get<ICountry[]>("/api/useroptions/countrycodes/");
    }

    getTimezones(): Observable<ITimeZoneInfo[]> {
        return this.http.get<ITimeZoneInfo[]>("/api/useroptions/timezones/");
    }

    updateAccountPreferences(accountPreferences: IPreferencesContent, accountId?: number): Observable<void> {
        return this.http.post<void>(`/api/preferences/account/${accountId}`, accountPreferences);
    }

    private setExistingPrefProperties(sourceModel: IPreferencesContent, targetModel: IPreferencesContent) {
        for (const property in sourceModel) {

            const preference = targetModel[property];
            if (!preference) {
                continue;
            }

            preference.savePreference = true;
        }
    }
}
